<template>
    <div class="">
    <masternav/>
      <b-nav class="navlinks ">
        <b-nav-item router-link :to="{ name: 'Home'}">
          <span class="navtext ">{{$t('help.nav1')}}</span>
        </b-nav-item>
          <span class="mt-2 text-secondary">/</span>
        <b-nav-item disabled>
            <span class="navtext2">Perfil de usuario</span>
        </b-nav-item>
      </b-nav>
      <br><br>
        <b-container>
            <b-row>
                <b-col>
                    <b-card title="Perfil" class="mb-5">
                        <hr>
                        <b-form @submit.prevent="modificarUsuario()">
                            <!--fila 1-->
                            <b-row>
                                <b-col>
                                    <b-form-group
                                        id="input-group-1"
                                        label="Nombre"
                                        label-for="input-1"
                                        description="">
                                        <b-form-input
                                        id="input-1"
                                        v-model="form.nombre"
                                        type="text"
                                        placeholder=""
                                        required
                                        ></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group
                                    id="input-group-2"
                                    label="Segundo nombre"
                                    label-for="input-2"
                                    description="">
                                    <b-form-input
                                    id="input-2"
                                    v-model="form.segundo_nombre"
                                    type="text"
                                    placeholder=""
                                    ></b-form-input>
                                </b-form-group>
                                </b-col>
                            </b-row>
                            <!--fila 1-->
                            <!--fila 2-->
                            <b-row>
                                <b-col>
                                    <b-form-group
                                        id="input-group-3"
                                        label="Apellido paterno"
                                        label-for="input-3"
                                        description="">
                                        <b-form-input
                                        id="input-3"
                                        v-model="form.apellido_paterno"
                                        type="text"
                                        placeholder=""
                                        required
                                        ></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group
                                    id="input-group-4"
                                    label="Apellido materno"
                                    label-for="input-4"
                                    description="">
                                    <b-form-input
                                    id="input-4"
                                    v-model="form.apellido_materno"
                                    type="text"
                                    placeholder=""
                                    ></b-form-input>
                                </b-form-group>
                                </b-col>
                            </b-row>
                            <!--fila 2-->
                            <!--fila 3-->
                            <b-row>
                                <b-col>
                                    <b-form-group
                                        id="input-group-5"
                                        label="Cédula/Pasaporte"
                                        label-for="input-5"
                                        description="">
                                        <b-form-input
                                        id="input-5"
                                        v-model="form.cedula"
                                        type="text"
                                        placeholder=""
                                        required
                                        ></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group
                                    id="input-group-6"
                                    label="País"
                                    label-for="input-6"
                                    description="">
                                    <b-form-input
                                    id="input-6"
                                    v-model="form.ced_pais"
                                    type="text"
                                    placeholder=""
                                    required
                                    ></b-form-input>
                                </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group
                                    id="input-group-7"
                                    label="Fecha de Nacimiento"
                                    label-for="input-7"
                                    description="">
                                    <b-form-input
                                    id="input-7"
                                    v-model="form.fecha_nacimiento"
                                    type="date"
                                    placeholder=""
                                    required
                                    ></b-form-input>
                                </b-form-group>
                                </b-col>
                            </b-row>
                            <!--fila 3-->
                            <!--fila 4-->
                            <b-row>
                                <b-col>
                                    <b-form-group
                                        id="input-group-8"
                                        label="Licencia"
                                        label-for="input-8"
                                        description="">
                                        <b-form-input
                                        id="input-8"
                                        v-model="form.num_licencia"
                                        type="text"
                                        placeholder=""
                                        required
                                        ></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group
                                    id="input-group-9"
                                    label="País"
                                    label-for="input-9"
                                    description="">
                                    <b-form-input
                                    id="input-9"
                                    v-model="form.licencia_pais"
                                    type="text"
                                    placeholder=""
                                    required
                                    ></b-form-input>
                                </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group
                                    id="input-group-10"
                                    label="Fecha de Vencimiento"
                                    label-for="input-10"
                                    description="">
                                    <b-form-input
                                    id="input-10"
                                    v-model="form.vence_licencia"
                                    type="date"
                                    placeholder=""
                                    required
                                    ></b-form-input>
                                </b-form-group>
                                </b-col>
                            </b-row>
                            <!--fila 4-->
                            <!--fila 5-->
                            <b-row>
                                <b-col>
                                    <b-form-group
                                        id="input-group-11"
                                        label="Lugar de trabajo"
                                        label-for="input-11"
                                        description="">
                                        <b-form-input
                                        id="input-11"
                                        v-model="form.trabajo"
                                        type="text"
                                        placeholder=""
                                        required
                                        ></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group
                                    id="input-group-12"
                                    label="Teléfono (trabajo)"
                                    label-for="input-12"
                                    description="">
                                    <b-form-input
                                    id="input-12"
                                    v-model="form.telefono_trabajo"
                                    type="text"
                                    placeholder=""
                                    required
                                    ></b-form-input>
                                </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group
                                    id="input-group-13"
                                    label="Celular (trabajo)"
                                    label-for="input-13"
                                    description="">
                                    <b-form-input
                                    id="input-13"
                                    v-model="form.cel_trabajo"
                                    type="text"
                                    placeholder=""
                                    ></b-form-input>
                                </b-form-group>
                                </b-col>
                            </b-row>
                            <!--fila 5-->
                            <h4>Residencia</h4>
                            <hr>
                            <!--fila 6-->
                            <b-row>
                                <b-col>
                                    <b-form-group
                                        id="input-group-14"
                                        label="País"
                                        label-for="input-14"
                                        description="">
                                        <b-form-input
                                        id="input-14"
                                        v-model="form.pais"
                                        type="text"
                                        placeholder=""
                                        required
                                        ></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group
                                    id="input-group-15"
                                    label="Ciudad"
                                    label-for="input-15"
                                    description="">
                                    <b-form-input
                                    id="input-15"
                                    v-model="form.ciudad"
                                    type="text"
                                    placeholder=""
                                    required
                                    ></b-form-input>
                                </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group
                                    id="input-group-16"
                                    label="Barrio"
                                    label-for="input-16"
                                    description="">
                                    <b-form-input
                                    id="input-16"
                                    v-model="form.barrio"
                                    type="text"
                                    placeholder=""
                                    required
                                    ></b-form-input>
                                </b-form-group>
                                </b-col>
                            </b-row>
                            <!--fila 6-->
                            <!--fila 7-->
                            <b-row>
                                <b-col>
                                    <b-form-group
                                        id="input-group-17"
                                        label="Calle"
                                        label-for="input-17"
                                        description="">
                                        <b-form-input
                                        id="input-17"
                                        v-model="form.calle"
                                        type="text"
                                        placeholder=""
                                        required
                                        ></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group
                                    id="input-group-18"
                                    label="Casa"
                                    label-for="input-18"
                                    description="">
                                    <b-form-input
                                    id="input-18"
                                    v-model="form.casa"
                                    type="text"
                                    placeholder=""
                                    required
                                    ></b-form-input>
                                </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group
                                    id="input-group-19"
                                    label="Teléfono"
                                    label-for="input-19"
                                    description="">
                                    <b-form-input
                                    id="input-19"
                                    v-model="form.telefono"
                                    type="text"
                                    placeholder=""
                                    required
                                    ></b-form-input>
                                </b-form-group>
                                </b-col>
                            </b-row>
                            <!--fila 7-->
                            <b-row>
                                <b-col>
                                    <b-btn class="btnConfirm" type="submit">
                                        Actualizar Datos
                                    </b-btn>
                                </b-col>
                            </b-row>
                        </b-form>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    <mainfooter/>
    </div>
</template>
<script>
import masternav      from '@/components/masternav.vue'
import maincontent    from '@/components/maincontent.vue'
import mainfooter     from '@/components/mainfooter.vue'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import axios from 'axios'
export default {
    name: 'Panel',
    metaInfo: {
      title: "Enterprise Panama - Panel | Alquiler de Autos",
      meta: [
        {
          vmid: 'A',
          name: 'description',
          content: 'Arriendo de vehiculos en Panamá. Empresa dedicada al arriendo de vehículos en Panamá, entre otros: automoviles, camionetas, van.',
        },
        {
          vmid: 'B',
          name: 'keywords',
          content: 'Enteprise panama, Enterprise rent a car, enterprise renta car, ALAMO, ENTERPRISE PANAMA, ALAMO PANAMA'
        }
      ]
    },
    components:{
        masternav,
        mainfooter,
        maincontent,
    },
    data() {
      return {
          form:{}
      }
    },
    mounted () {
        this.editUser()
    },
    methods: {
      editUser()
      {
          axios.post('user').then(resp=>{
              this.form = resp.data
          })
      },
      modificarUsuario(){
          
        axios.put('update-user', this.form).then(resp=>{
            
            if (resp.data == "ok") {

                this.$bvToast.toast('Usuario Actualizado correctamente',{
                title: 'confirmado',
                variant: 'success',
                toaster: 'b-toaster-bottom-right',
                solid: true
                })
                 this.$store.dispatch("autenticacion/getUser")
            }
        })

      },
      
  },
}
</script>
<style  scoped>
@font-face {
    font-family: 'DIN 2014-ExraBold';
    src: url('../assets/fonts/DIN2014-ExtraBold.ttf');

}
@font-face {
    font-family: 'DIN 2014-Regular';
    src: url('../assets/fonts/DIN2014-Regular.ttf');
}
input{
    border-radius: 0px;
}
input:focus{
        outline: none;
        border-color: #169A5A;
        box-shadow: 0 0 3px #169A5A;
}
.btnConfirm{
    
    font-weight: 700;
    font-style: normal;
    display: inline-block;
    padding: 0.5em 1em;
    border: 0;
    margin: 0;
    border-radius: 0%;
    float: right;
    min-height: auto;
    background: #169a5a;
    color: white;
    line-height: inherit;
    letter-spacing: .0675rem;
    font-size: .875rem;
    text-align: center;
    text-transform: uppercase;
}
.navlinks{
    border-bottom: solid 0.05px rgb(185, 185, 185);
    
}
.navtext{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    color: #169a5a !important;
    font-size: 14px;
    font-weight: 300;
}
.navtext2{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    color: #686e6b !important;
    font-size: 14px;
    font-weight: 300;
}
</style>